<template>
  <HXContentCard title="Registro de Novedades" defaultToBack>
    <div class="p-4">
      <h4 class="card-title text-white mb-3"><b>Trabajador</b></h4>
      <b-form @submit.prevent="searchingWorker"> </b-form>
      <article v-if="worker.about" class="mt-4">
        <b-list-group class="info-worker my-3">
          <b-list-group-item class="flex-column align-items-start">
            <div class="d-flex w-100 justify-content-between">
              <h3>
                <strong>
                  {{ worker.about.apellidos }}
                  {{ worker.about.segundoApellido }} {{ worker.about.nombres }}
                  {{ worker.about.segundoNombre }}
                </strong>
              </h3>
            </div>
            <div class="mt-2 d-flex" style="gap: 1rem">
              <span>
                <strong>Cédula de ciudadanía</strong>
                <br />
                {{ worker.about.numeroDocumento }}
              </span>

              <span>
                <strong>Salario</strong>
                <br />{{
                  Number(worker.about.salario).toLocaleString("es-CO", {
                    style: "currency",
                    currency: "COP",
                  })
                }}
              </span>
              <span>
                <strong>Fecha contratación</strong><br />
                {{
                  $moment.tz(worker.about.fechaContratacion, "America/Bogota").format("DD-MM-YYYY hh:mm A"),
                }}
              </span>
            </div>
          </b-list-group-item>
        </b-list-group>
        <b-list-group v-if="Registro" class="info-worker my-3">
          <b-list-group-item class="flex-column align-items-start">
            <div class="d-flex w-100 justify-content-between">
              <h3>
                <strong> Fechas de liquidación </strong>
              </h3>
            </div>
            <div class="mt-2 d-flex" style="gap: 1rem">
              <span>
                <strong>Fecha Inicio</strong>
                <br />
                {{ Nomina.fechaInicio.split("T")[0] }}
              </span>
              <span>
                <strong>Fecha Fin</strong>
                <br />
                {{ Nomina.fechaFin.split("T")[0] }}
              </span>
            </div>
          </b-list-group-item>
        </b-list-group>
        <div class="table-responsive px-4 mt-3">
          <table id="datatablenovedades" class="table table-bordered table-responsive-md table-striped text-center">
            <thead>
              <tr>
                <th>Novedad</th>
                <th>Valor</th>
                <th>Fecha Registro</th>
                <th>Fecha inicio</th>
                <th>Fecha Fin</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in incapacidades" :key="item.id">
                <template v-if="
                  (item.conceptoId > 3 && item.tipoNovedadId == 1) ||
                  (item.conceptoId > 2 && item.tipoNovedadId == 2)
                ">
                  <td>{{ item.novedad }}</td>
                  <td>
                    ${{
                      item.tipoNovedadId == 1
                        ? item.tDed.toFixed(2)
                        : item.tDev.toFixed(2)
                    }}
                  </td>
                  <td>
                    {{
                      $moment
                        .tz(item.fechaRegistro, "America/Bogota")
                        .format("DD-MM-YYYY HH:mm")
                    }}
                  </td>
                  <td>
                    {{
                      $moment
                        .tz(item.fechaInicio, "America/Bogota")
                        .format("DD-MM-YYYY HH:mm")
                    }}
                  </td>
                  <td>
                    {{
                      $moment
                        .tz(item.fechaFin, "America/Bogota")
                        .format("DD-MM-YYYY HH:mm")
                    }}
                  </td>
                  <td>
                    <!-- <span class="pointer"><i @click="editRow(item)"
                        class="fas fa-solid fa-pencil px-1 text-success mr-1"></i> </span> -->
                    <span class="pointer"><i @click="deleteRow(item)"
                        class="fas fa-solid fa-trash px-1 text-danger"></i>
                    </span>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </article>
    </div>
    <card class="shadow-none">
      <template v-slot:headerTitle>
        <h4 class="card-title text-white"><b>Registrar novedad</b></h4>
        {{ newForm.tipoDeEvento }}
      </template>
      <div class="card-body">
        <article class="nueva-incapacidad">
          <div class="d-flex justify-content-center">
            <vs-button style="width: 200px" v-show="!hasForm" @click="createForm" :disabled="!worker.about">
              <i class="fas fa-plus-circle pr-1"></i>
              Agregar nueva novedad
            </vs-button>
            <vs-button style="width: 200px" danger v-show="hasForm" @click="cancelForm"><i
                class="fas fa-xmark mr-1"></i>Cancelar
            </vs-button>
          </div>
        </article>
        <!-- <b-form v-if="hasForm" @submit.prevent="guardarDataUsuario()" class="my-4"> -->
        <b-form v-if="hasForm" @submit.prevent="guardarDataUsuario()" class="my-4">
          <div class="row align-items-center px-3" style="gap: 5px">
            <!-- tipo de evento -->
            <b-form-group label-for="tipoDeEvento" label="Tipo de evento" class="col-md-3 p-0 mb-2 mt-2 mt-md-0">
              <b-form-select id="tipoDeEvento" v-model="newForm.TipoNovedadId" :options="tipoDeEvento"
                required></b-form-select>
            </b-form-group>

            <div v-if="newForm.TipoNovedadId == 1" class="col-md-3 p-0 mb-2 mt-2 mt-md-0">
              <label for=" " class="form-label">Tipo de deducción</label>
              <b-form-select v-model="newForm.conceptoId" required @change="selecionarItem($event, 'deduccion')"
                value-field="id" text-field="descripcion" :options="listaDeducciones"></b-form-select>
            </div>
            <div class="col-md-3 p-0 mb-2 mt-2 mt-md-0" v-if="newForm.TipoNovedadId == 2">
              <label for=" " class="form-label">Tipo de devengado</label>
              <b-form-select v-model="newForm.conceptoId" required @change="
                selecionarItem($event, 'devengado');
              diffDate();
              " value-field="id" text-field="descripcion" :options="listaDevengados"></b-form-select>
            </div>

            <!-- fecha inicio -->
            <b-form-group label-for="fechaInicio" label="Fecha inicio" class="col-md-2 p-0 mb-2 mt-2 mt-md-0">
              <b-form-input v-on:keyup="diffDate()" @blur="diffDate()" type="datetime-local" id="fechaInicio"
                :max="newForm.FechaFin" v-model="newForm.FechaInicio" @input="cambiarValor" required></b-form-input>
            </b-form-group>
            <!-- fecha fin -->
            <b-form-group label-for="fechaFinal" label="" class="col-md-1 p-0 mb-2 mt-2 mt-md-0 text-center">
              <div class="d-flex">
                <vs-button style="width: 50%" icon success @click="
                  newForm.FechaFin = newForm.FechaInicio;
                diffDate();
                fechaCondicion = 1;
                " type="button" class="mt-3"><i class="fa-solid fa-play"></i></vs-button>
                <vs-button style="width: 50%" icon @click="
                  ultimoDia();
                fechaCondicion = 2;
                " type="button" class="mt-3"><i class="fa-solid fa-forward-step"></i></vs-button>
              </div>
            </b-form-group>
            <b-form-group label-for="fechaFinal" label="Fecha final" class="col-md-2 p-0 mb-2 mt-2 mt-md-0">
              <b-form-input :style="fechaCondicion == '1'
                ? 'border: solid 2px #16a76b;'
                : fechaCondicion == 2
                  ? 'border: solid 2px #186bdd;'
                  : ''
                " v-on:keyup="diffDate()" @blur="diffDate()" type="datetime-local" id="fechaFinal"
                :min="newForm.FechaInicio" v-model="newForm.FechaFin" required></b-form-input>
            </b-form-group>
          </div>

          <i v-if="this.newForm.formula">Formula: {{ newForm.formula }}</i>

          <!-- deducciones -->

          <template v-if="newForm.TipoNovedadId == 1">
            <div class="row mt-2 px-3" style="gap: 5px">
              <div class="col-md-4 p-0 mb-2 mt-2 mt-md-0" v-for="(item, index) in newForm.campos" :key="index">
                <label for="exampleFormControlInput1" class="form-label">
                  {{ item }}
                </label>
                <input v-on:keyup="calculoNuevoItem" required onfocus="this.select()" v-model="newForm[item]"
                  type="number" class="form-control" id="exampleFormControlInput1" placeholder="" />
              </div>
              <div class="col-md-4 p-0 mt-2 mt-md-0">
                <label for="exampleFormControlInput1" class="form-label">
                  Costo reflejado en Nómina
                </label>
                <label class="form-control">
                  {{
                    newForm.total
                      ? Number(newForm.total).toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                      })
                      : 0.0
                  }}
                </label>
              </div>
            </div>
          </template>

          <template v-if="newForm.TipoNovedadId == 2">
            <div class="row mt-2 px-3" style="gap: 5px">
              <div class="col-md-4 p-0 mb-2 mt-2 mt-md-0" v-for="(item, index) in newForm.campos" :key="index">
                <label for="exampleFormControlInput1" class="form-label">
                  {{ item }}
                </label>
                <input v-if="item === 'horas'" onClick="this.select()" readonly required v-on:keyup="calculoNuevoItem"
                  onfocus="this.select()" v-model="newForm[item]" type="number" class="form-control"
                  id="exampleFormControlInput1" placeholder="" />
                <input v-else-if="item === 'dias'" onClick="this.select()" readonly required
                  v-on:keyup="calculoNuevoItem" onfocus="this.select()" v-model="newForm[item]" type="number"
                  class="form-control" id="exampleFormControlInput1" placeholder="" />
                <b-form-select @change="calculoNuevoItem()" value-field="value" text-field="descripcion"
                  v-else-if="newForm.porcentajes.length > 0" :options="newForm.porcentajes" v-model="newForm[item]">
                </b-form-select>
                <input v-else v-on:keyup="calculoNuevoItem" required onfocus="this.select()" v-model="newForm[item]"
                  type="number" class="form-control" id="exampleFormControlInput1" placeholder="" />
              </div>
              <div class="col-md-4 p-0 mt-2 mt-md-0">
                <label for="exampleFormControlInput1" class="form-label">
                  Costo reflejado en Nómina
                </label>
                <label class="form-control">
                  {{
                    newForm.total
                      ? Number(newForm.total).toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                      })
                      : 0.0
                  }}
                </label>
              </div>
            </div>
            <b-form-group label-for="observaciones" label="Observaciones" class="col-md-12 p-0 mt-2 mt-2 mt-md-0">
              <b-form-textarea id="observaciones" v-model="newForm.Observaciones" rows="3"
                max-rows="12"></b-form-textarea>
            </b-form-group>
          </template>

          <div class="w-100 d-flex justify-content-center">
            <b-button :disabled="nominaConfiguracion === null" type="submit" class="mt-3 w-30" variant="primary"><i
                class="fas fa-check-circle"></i> Registrar</b-button>
          </div>
        </b-form>
      </div>
    </card>
  </HXContentCard>
</template>
<script>
// import codigosCIE10 from "./optionsCodigoCIE10";
// import EPSs from "./EPSs";
const Swal = require("sweetalert2");
import { core } from "../../../../config/pluginInit";

export default {
  name: "DataTable",
  data() {
    return {
      fechaCondicion: 0,
      Registro: this.$route.params.liquidacionId ? true : false,
      worker: {
        searching: false,
        imputSearchWorker: null,
        stateErrorWorker: null,
        about: null,
      },
      hasForm: false,
      tipoEv: null,
      tipoDeEvento: [
        { value: 1, text: "Deducción" },
        { value: 2, text: "Devengado" },
      ],
      formDataBase: {
        codigosCIE10: null,
        EPSs: null,
      },
      newForm: {},
      incapacidades: [],
      listaDeducciones: [],
      listaDevengadosNovedades: [],
      listaDevengados: [],
      usuario: {},
      nominaLiquidacionPersonaDetalle: [],
      timeout: null,
      id: null,
      nominaConfiguracion: {},
      Nomina: {},
      listaLiquidacion: [],
    };
  },
  async mounted() {
    this.$isLoading(true);
    this.id = this.$route.params.Id;
    this.searchingWorker();
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
    if (this.$route.params.liquidacionId) {
      this.Nomina = await this.$store.dispatch("hl_get", {
        path: `NominaLiquidacion/GetLiquidacionById/${this.$route.params.liquidacionId}`,
      });
      await this.getNominaConfiguracion(this.Nomina.fechaInicio.slice(0, 10));
    } 

    if (!this.$route.params.liquidacionId) {
      await this.GetLiquidacionNomina();
    }
    this.$isLoading(false);
  },
  methods: {
    async cambiarValor() {
      console.log('Nuevo valor:', this.newForm.FechaInicio);
      await this.getNominaConfiguracion(this.newForm.FechaInicio.slice(0, 10));
    },
    async GetLiquidacionNomina() {
      const nomina = await this.$store.dispatch("hl_get", {
        path:
          "NominaLiquidacion/GetNominaLiquidacion/" + this.usuario.empresa.id,
      });
      nomina.forEach((item) => {
        this.listaLiquidacion.push({
          ...item,
          nomina:
            this.$moment
              .tz(item.fechaInicio, "America/Costa_Rica")
              .format("DD-MM-YYYY") +
            " / " +
            this.$moment
              .tz(item.fechaFin, "America/Costa_Rica")
              .format("DD-MM-YYYY"),
        });
      });
    },
    ultimoDia() {
      const getLastDayOfMonth = (date) =>
        new Date(date.getFullYear(), date.getMonth() + 1, 0);
      let FechaFin = getLastDayOfMonth(new Date(this.newForm.FechaInicio));
      this.newForm.FechaFin = this.$moment(new Date(FechaFin)).format(
        "YYYY-MM-DDTHH:mm"
      );
      this.diffDate();
    },
    async getNominaConfiguracion(fecha) {
      console.log("fecha", fecha);
      try {
        let res = await this.$store.dispatch("hl_get", {
          path:
            "NominaConfiguracion/GetNominaConfiguracion/" + fecha,
        });
        console.log("res config", res);
        let resSalario = await this.$store.dispatch("hl_get", {
          path:
            `HistorialCambios/GetHistorialCambios/Salario/${fecha}/${this.worker.about.id}`,
        });

        if (res.respuesta === false) {
          this.nominaConfiguracion = null;
          Swal.fire("Error!", res.mensaje, "error");
          return;
        }
        if (resSalario.respuesta === true) {
          this.worker.about.salario = resSalario.data.salario
          console.log("resSalario", resSalario);
        }
        this.nominaConfiguracion = res.data;
      } catch (error) {
        this.nominaConfiguracion = null;
        Swal.fire("Error!", "No se encontro configuracion de nomina para esta fechas.", "error");
        console.error("err", error);
      }
    },
    editRow(it) {
      this.createForm();
      this.newForm.TipoNovedadId = it.tipoNovedadId;
      this.newForm.conceptoId = it.conceptoId;
      this.newForm.FechaInicio = it.fechaInicio;
      this.newForm.FechaFin = it.fechaFin;
      this.newForm.valor = it.baseLiquida;
      this.calculoNuevoItem();
      this.diffDate();
    },
    async deleteRow(item) {
      try {
        Swal.fire({
          title: "¿Seguro eliminar item?",
          text: "Después de eliminarlo no podrás recuperarlo!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si!",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              this.$isLoading(true);
              let res = await this.$store.dispatch("hl_delete", {
                path: "NominaLiquidacion/DelNominaLiquidacionPersonaItem",
                data: item,
              });
              if (res.status == 400) {
                this.$isLoading(false);
                Swal.fire("Error!", "Intentalo nuevamente.", "error");
              } else {
                await this.initNovedades(this.id);
                this.$isLoading(false);
                Swal.fire(
                  "Listo!",
                  "Registro eliminado correctamente.",
                  "success"
                );
                this.$forceUpdate();
              }
            } catch (error) {
              this.$isLoading(false);
              Swal.fire("Error!", "Intentalo nuevamente.", "error");
              console.error("error", error);
            }
          }
        });
      } catch (error) {
        console.error("error", error);
      }
    },
    async guardarDataUsuario() {
      try {
        this.$isLoading(true);
        let dataUsuario = [];
        await this.agregarNuevoItem();
        dataUsuario = this.nominaLiquidacionPersonaDetalle[0];

        dataUsuario.TipoNovedadId = this.newForm.TipoNovedadId;
        dataUsuario.FechaInicio = this.$moment
          .tz(new Date(this.newForm.FechaInicio), "America/Bogota")
          .format("YYYY-MM-DDTHH:mm:ss");
        dataUsuario.FechaFin = this.$moment
          .tz(new Date(this.newForm.FechaFin), "America/Bogota")
          .format("YYYY-MM-DDTHH:mm:ss");
        dataUsuario.PersonaIdRegistro = this.usuario.id;
        dataUsuario.Observaciones = this.newForm.Observaciones;
        dataUsuario.SalarioPersona = this.worker.about.salario;
        dataUsuario.PersonaId = this.worker.about.id;
        dataUsuario.ConceptoId = this.newForm.conceptoId;

        dataUsuario.FechaRegistro = this.$moment
          .tz(new Date(), "America/Bogota")
          .format("YYYY-MM-DDTHH:mm:ss");

        let res;

        const fechaInicioNovedad = new Date(dataUsuario.FechaInicio);
        const fechaFinNovedad = new Date(dataUsuario.FechaFin);
        const fechaInicioNomina = new Date(this.Nomina.fechaInicio);
        const fechaFinNomina = new Date(this.Nomina.fechaFin);

        const fueraDeRango =
          (fechaInicioNovedad < fechaInicioNomina && fechaFinNovedad < fechaInicioNomina) ||
          (fechaInicioNovedad > fechaFinNomina && fechaFinNovedad > fechaFinNomina);


        console.log("validacion", fueraDeRango);

        if (this.$route.params.liquidacionId) {
          if (!fueraDeRango) {
            res = await this.$store.dispatch("hl_post", {
              path: `NominaLiquidacion/NominaLiquidacionPersonaDetalle/${this.$route.params.liquidacionId}`,
              data: dataUsuario,
            });
          }else {
            this.$isLoading(false);
            Swal.fire(
              "Error!",
              "Por favor revisar que la fechas de inicio y fin sean correctas.",
              "error"
            );
            return;
          }
        } else {
          res = await this.$store.dispatch("hl_post", {
            path: `NominaLiquidacion/NominaLiquidacionPersonaDetalle/`,
            data: dataUsuario,
          });
        }

        console.log("res", res);

        if (res === 0 || res.status === 400) {
          this.$isLoading(false);
          Swal.fire("Error!", "Intentalo nuevamente.", "error");
          return;
        }

        this.$isLoading(false);
        this.nominaLiquidacionPersonaDetalle = [];
        this.newForm = {};
        Swal.fire("Muy bien!", "Datos almacenados correctamente.", "success");
        await this.initNovedades(this.id);
        this.$forceUpdate();
      } catch (error) {
        this.nominaLiquidacionPersonaDetalle = [];
        this.$forceUpdate();
        this.$isLoading(false);
        Swal.fire("Error!", "Intentalo nuevamente.", "error");
      }
    },
    async calcularHoras() {
      let fechaFin = this.$moment(this.newForm.FechaFin);
      var diferenciaEnMilisegundos = fechaFin.diff(this.newForm.FechaInicio);

      var horas = this.$moment.duration(diferenciaEnMilisegundos).asHours();
      this.newForm.dias = this.$moment
        .duration(diferenciaEnMilisegundos)
        .asDays();
      return horas.toFixed(2);
    },
    calculoNuevoItem() {
      setTimeout(async () => {
        const { concepto, tipo } = this.newForm;
        const novedad =
          tipo === "deduccion"
            ? this.listaDeducciones.find(
              (item) => item.descripcion === concepto
            )
            : this.listaDevengados.find(
              (item) => item.descripcion === concepto
            );

        let formula = this.newForm.formula;
        let horasMes = this.nominaConfiguracion.horasMensuajes;

        console.log("horasMes", horasMes);

        for (let index = 0; index < novedad.campos.length; index++) {
          const campo = novedad.campos[index];
          formula = formula.replace(
            new RegExp(`\\b${campo}\\b`, "g"),
            this.newForm[campo] || 0
          );
        }

        formula = formula.replace(/salario/g, this.worker.about.salario || 0);
        formula = formula.replace(/horasmes/g, horasMes || 0);

        this.newForm.total = eval(formula);
        this.$forceUpdate();
      });
    },
    obtenerDescripcionItem(tipo, itemId) {
      if (tipo == "devengado") {
        let res = this.listaDevengados.find((x) => x.id == itemId);
        return res.descripcion;
      } else {
        let res = this.listaDeducciones.find((x) => x.id == itemId);
        return res.descripcion;
      }
    },
    async selecionarItem(e, tipo) {
      try {
        this.newForm.porcentajes = [];
        this.newForm.porcentaje ? delete this.newForm.porcentaje : null;

        const res =
          tipo === "devengado"
            ? this.listaDevengados.find((x) => x.id == e)
            : this.listaDeducciones.find((x) => x.id == e);

        res.campos = eval(res.campos);
        res.porcentajes = res.porcentajes ? eval(res.porcentajes) : [];

        this.newForm.tipo = tipo;
        this.newForm.conceptoId = e;
        this.newForm.total = 0;
        this.newForm.formula = res.formula;
        this.newForm.campos = res.campos;
        for (let i = 0; i < res.campos.length; i++) {
          this.newForm[res.campos[i]] = 0;
        }
        this.newForm.porcentajes = res.porcentajes?.map((x) => {
          return {
            value: x,
            descripcion: `${x} %`,
          };
        });
        // res.porcentajes.length > 0 ? this.newForm.porcentajes = res.porcentajes : delete this.newForm.porcentajes;
        this.newForm.concepto = this.obtenerDescripcionItem(
          tipo,
          this.newForm.conceptoId
        );
        this.$forceUpdate();
      } catch (error) {
        console.error("error", error);
      }
    },
    async agregarNuevoItem() {
      try {
        if (this.newForm.TipoNovedadId == 2) {
          // //DEVENGADOS
          let itDevengados = this.listaDevengados.find(
            (x) => x.id == this.newForm.conceptoId
          );
          switch (itDevengados.descripcion) {
            case "Cesantías":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.worker.about.salario,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: this.nominaConfiguracion.cesantias,
                valorEmpleador: (
                  (this.worker.about.salario *
                    this.nominaConfiguracion.cesantias) /
                  100
                ).toFixed(2),
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: this.newForm.total,
                tDev: this.newForm.total,
                tDed: 0,
              });
              break;
            case "Prima salarial":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.worker.about.salario,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: this.nominaConfiguracion.primaDeServicios,
                valorEmpleador: (
                  (this.worker.about.salario *
                    this.nominaConfiguracion.primaDeServicios) /
                  100
                ).toFixed(2),
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: this.newForm.valor,
                tDev: this.newForm.total,
                tDed: 0,
              });
              break;
            case "Viáticos salariales":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.valor,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                valor: this.newForm.valor,
                tDev: this.newForm.valor,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Viáticos no salariales":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.valor,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                valor: this.newForm.valor,
                tDev: this.newForm.valor,
                tDed: 0,
              });
              break;
            case "Horas extras diurnas":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0.25,
                valorEmpleador: 0,
                Dias: 0,
                horas: this.newForm.horas,
                valor: this.newForm.total,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Horas extras nocturnas":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0.75,
                valorEmpleador: 0,
                Dias: 0,
                horas: this.newForm.horas,
                valor: this.newForm.total,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Horas extras dominicales y festivas":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 1,
                valorEmpleador: 0,
                Dias: 0,
                horas: this.newForm.horas,
                valor: this.newForm.total,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Horas extras nocturnas dominicales y festivas":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 1.5,
                valorEmpleador: 0,
                Dias: 0,
                horas: this.newForm.horas,
                valor: this.newForm.total,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Horas recargo nocturno":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0.35,
                valorEmpleador: 0,
                Dias: 0,
                horas: this.newForm.horas,
                valor: this.newForm.total,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Horas recargo dominical y festiva":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: this.porcenta,
                valorEmpleador: 0,
                Dias: 0,
                horas: this.newForm.horas,
                valor: this.newForm.total,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Hora recargo nocturno dominical y festivos":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: this.porcenta2,
                valorEmpleador: 0,
                Dias: 0,
                horas: this.newForm.horas,
                valor: this.newForm.total,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Vacaciones disfrutadas":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: this.newForm.valor,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Vacaciones compensadas no disfrutadas":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: this.newForm.valor,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Prima no salarial":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: 0,
                valor: this.newForm.valor,
                tDev: this.newForm.total,
                tDed: 0,
              });
              break;
            // case "Incapacidad común":
            //   this.nominaLiquidacionPersonaDetalle.push({
            //     baseLiquida: this.newForm.total,
            //     porcentajeTrabajador: 0,
            //     valorTrabajador: 0,
            //     porcentajeEmpleador: 0,
            //     valorEmpleador: 0,
            //     Dias: this.newForm.dias,
            //     horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
            //     valor: 0,
            //     tDev: this.newForm.total,
            //     tDed: 0,
            //   });
            //   break;
            // case "Incapacidad profesional":
            //   this.nominaLiquidacionPersonaDetalle.push({
            //     baseLiquida: this.newForm.total,
            //     porcentajeTrabajador: 0,
            //     valorTrabajador: 0,
            //     porcentajeEmpleador: 0,
            //     valorEmpleador: 0,
            //     Dias: this.newForm.dias,
            //     valor: 0,
            //     tDev: this.newForm.total,
            //     tDed: 0,
            //   });
            //   break;
            // case "Incapacidad laboral":
            //   this.nominaLiquidacionPersonaDetalle.push({
            //     baseLiquida: this.newForm.total,
            //     porcentajeTrabajador: 0,
            //     valorTrabajador: 0,
            //     porcentajeEmpleador: 0,
            //     valorEmpleador: 0,
            //     Dias: this.newForm.dias,
            //     valor: 0,
            //     tDev: this.newForm.total,
            //     tDed: 0,
            //   });
            //   break;
            case "Licencia de maternidad o paternidad":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Licencia remunerada":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Licencia no remunerada":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: 0,
                tDed: this.newForm.total,
              });
              // this.newForm = {};

              break;
            case "Bonificación salarial":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Bonificación no salarial":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });
              // this.newForm = {};

              break;
            case "Auxilio salarial":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });
              break;
            case "Auxilio no salarial":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Huelga legal":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Otro concepto salarial":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Otro concepto no salarial":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Compensación ordinaria":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Compensación extraordinaria":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Bono de alimentación salarial":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Bono de alimentación no salarial":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Otros bonos salariales":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Otros bonos no salariales":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Comisión":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Pago a terceros":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Anticipo":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Dotación":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Apoyo sostenimiento":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Teletrabajo":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Bonificación por retiro":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Indemnización":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            case "Reintegro":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias,
                horas: (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias,
                valor: 0,
                tDev: this.newForm.total,
                tDed: 0,
              });

              break;
            default:
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                Dias: this.newForm.dias || 0,
                horas: this.newForm.horas > 0 ? this.newForm.horas : this.newForm.dias > 0 ? (this.nominaConfiguracion.horasMensuajes / 30) * this.newForm.dias : 0,
                valor: this.newForm.valor,
                tDev: this.newForm.total,
                tDed: 0,
              });
              break;
          }
        } else {
          let itDeduccion = this.listaDeducciones.find(
            (x) => x.id == this.newForm.conceptoId
          );

          switch (itDeduccion.descripcion) {
            case "Sindicato":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Sanción pública":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Sanción privada":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Libranza":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Pago a terceros":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Anticipos":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Otras deducciones":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Pensión voluntaria":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Retención en la fuente":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "AFC":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Cooperativa":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Embargo fiscal":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Plan complementario":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Educación":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Reintegro":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            case "Deuda":
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: 0,
                valor: this.newForm.valor,
                tDed: this.newForm.total,
                tDev: 0,
              });

              break;
            default:
              this.nominaLiquidacionPersonaDetalle.push({
                baseLiquida: this.newForm.total,
                porcentajeTrabajador: 0,
                valorTrabajador: 0,
                porcentajeEmpleador: 0,
                valorEmpleador: 0,
                dias: this.newForm.dias,
                valor: this.newForm.valor,
                tDev: 0,
                tDed: this.newForm.total
              });
              break;
          }
        }
      } catch (error) {
        console.error("error", error);
      }
    },
    actualizaNovedad(e) {
      this.newForm.EventualidadId = e;
    },
    calculateDays(FechaInicio, FechaFin) {
      let fechaInicio = new Date(FechaInicio);
      let fechaFin = new Date(FechaFin);
      let diff = fechaFin.getTime() - fechaInicio.getTime();
      let dias = diff / (1000 * 60 * 60 * 24) + 1;
      return dias;
    },
    async diffDate() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        let hora = this.newForm.campos.find((x) => x == "horas");
        let dias = this.newForm.campos.find((x) => x == "dias");
        if (
          this.newForm.FechaFin &&
          this.newForm.FechaInicio &&
          (hora || dias)
        ) {
          const days = this.calculateDays(
            this.newForm.FechaInicio,
            this.newForm.FechaFin
          );

          if (dias) {
            this.newForm.dias = days.toFixed(0);
          }

          if (hora) {
            this.newForm.horas = await this.calcularHoras();
          }

          this.calculoNuevoItem();
        } else {
          this.newForm.dias = 0;
          this.newForm.horas = 0;
          this.newForm.valor = 0;
        }
        this.$forceUpdate();
      }, 1000);
    },
    async getDevengados() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Devengado/GetDevengados/" + this.usuario.empresa.id,
        });
        console.log("res", res);

        let excluir = ["Salario", "Auxilio de transporte"];

        this.listaDevengadosNovedades = res.filter(
          (x) => !excluir.includes(x.descripcion)
        );

        excluir.push(
          "Incapacidad común",
          "Incapacidad laboral",
          "Incapacidad profesional",
          "Salario Integral",
        );
        this.listaDevengados = res.filter(
          (x) => !excluir.includes(x.descripcion)
        );
      } catch (error) {
        this.listaDevengados = {};
        console.error("err", error);
      }
    },
    async getDeducciones() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Deduccion/GetDeducciones/" + this.usuario.empresa.id,
        });
        console.log("res", res);

        let excluir = [
          "Salud",
          "Fondo de pensión",
          "Fondo de solidaridad pensional",
        ];
        this.listaDeducciones = res.filter(
          (x) => !excluir.includes(x.descripcion)
        );
      } catch (error) {
        this.listaDeducciones = {};
        console.error("err", error);
      }
    },
    searchingWorker() {
      this.worker.searching = true;
      this.$store
        .dispatch("get", {
          path: `Persona/GetPersonaById/${this.id}`,
        })
        .then((result) => {
          return new Promise((resolve, reject) => {
            result = result.traceId ? null : result;
            if (result) {
              resolve(result);
            } else {
              reject("Trabajador no encontrado");
            }
          });
        })
        .then(async (result) => {
          this.worker.stateErrorWorker = null;
          this.worker.about = result;
          await this.getDevengados();
          await this.getDeducciones();
          await this.initNovedades(this.id);
          core.index();
          window.$("#datatablenovedades").DataTable({
            language: {
              url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
            },
          });
          this.$forceUpdate();
        })
        .catch((error) => {
          this.worker.stateErrorWorker = false;
          this.worker.about = null;
          console.error(error);
        })
        .finally(() => {
          this.worker.searching = false;
        });
    },
    async initNovedades(personaId) {
      let liquidacion = this.$route.params.liquidacionId
        ? this.$route.params.liquidacionId
        : 0;
      let result = await this.$store.dispatch("get", {
        path: `NominaLiquidacion/GetNominaLiquidacionPersonaDetalle/${personaId}/${liquidacion}`,
      });

      let resultadoFinal = [];
      for await (let item of result) {
        //deducción
        if (item.tipoNovedadId == 1) {
          item.novedad = this.listaDeducciones.find(
            (x) => x.id == item.conceptoId
          );

          if (item.novedad) {
            item.novedad = item.novedad ? item.novedad.descripcion : "-";
            resultadoFinal.push(item);
          }
        } else {
          item.novedad = this.listaDevengadosNovedades.find(
            (x) => x.id == item.conceptoId
          );

          if (item.novedad) {
            item.novedad = item.novedad ? item.novedad.descripcion : "--";
            resultadoFinal.push(item);
          }
          //devengado
        }
      }
      console.log("resultadoFinal", resultadoFinal);
      this.incapacidades = resultadoFinal;
    },
    initNewForm() {
      this.newForm = {
        PersonaId: null,
        TipoId: null,
        EventualidadId: null,
        FechaInicio: null,
        FechaFin: null,
        Importe: null,
        Dias: null,
        FechaRegistro: null,
        concepto: null,
      };
    },
    async createForm() {
      this.hasForm = true;
      this.initNewForm();

      if (this.$route.params.liquidacionId){
        this.newForm.FechaInicio = this.$moment
                      .tz(new Date(this.Nomina.fechaInicio), "America/Bogota")
          .format("YYYY-MM-DD HH:mm")
        this.newForm.FechaFin = this.$moment
          .tz(new Date(this.Nomina.fechaFin), "America/Bogota")
          .format("YYYY-MM-DD HH:mm")
      }else{
        this.newForm.FechaInicio = this.$moment
          .tz(new Date(), "America/Bogota")
          .format("YYYY-MM-DD HH:mm")
        this.newForm.FechaFin = this.$moment
          .tz(new Date(), "America/Bogota")
          .format("YYYY-MM-DD HH:mm")
      }

      await this.getNominaConfiguracion(this.newForm.FechaInicio);
    },
    cancelForm() {
      this.hasForm = false;
      this.newForm = {};
      this.nominaLiquidacionPersonaDetalle = [];
    },
  },
  computed: {
    salarioBaseDia() {
      return Number.parseFloat(this.newForm.salarioBase / 30).toFixed(2);
    },
  },
};
</script>

<style>
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 0px;
}
</style>
